export const PREFIX_EXPORT_KEY = 'export_key_' as const;

export const SITE_COLUMN = Object.freeze( {
  NAME: `${ PREFIX_EXPORT_KEY }site_name`,
  ADDRESS: `${ PREFIX_EXPORT_KEY }address`,
  ADDITIONAL_ADDRESS: `${ PREFIX_EXPORT_KEY }additional_address`,
  ZIP_CODE: `${ PREFIX_EXPORT_KEY }zip_code`,
  CITY: `${ PREFIX_EXPORT_KEY }city`,
  COUNTRY: `${ PREFIX_EXPORT_KEY }country`,
} as const );

export const SECTOR_COLUMN = Object.freeze( {
  SITE_NAME: `${ PREFIX_EXPORT_KEY }site_name`,
  NAME: `${ PREFIX_EXPORT_KEY }sector_name`,
} as const );

export const USER_COLUMN = Object.freeze( {
  SITE_NAME: `${ PREFIX_EXPORT_KEY }site_name`,
  IS_SITE_ADMIN: `${ PREFIX_EXPORT_KEY }is_site_admin`,
  SECTOR_NAME: `${ PREFIX_EXPORT_KEY }sector_name`,
  IS_SECTOR_ADMIN: `${ PREFIX_EXPORT_KEY }is_sector_admin`,
  FIRSTNAME: `${ PREFIX_EXPORT_KEY }firstname`,
  LASTNAME: `${ PREFIX_EXPORT_KEY }lastname`,
  EMAIL: `${ PREFIX_EXPORT_KEY }email`,
  LANGUAGE: `${ PREFIX_EXPORT_KEY }language`,
} as const );

export const SKILL_COLUMN = Object.freeze( {
  SITE_NAME: `${ PREFIX_EXPORT_KEY }site_name`,
  NAME: `${ PREFIX_EXPORT_KEY }skill_name`,
  COLOR: `${ PREFIX_EXPORT_KEY }color`,
  EMAIL: `${ PREFIX_EXPORT_KEY }email`,
  ILUO: `${ PREFIX_EXPORT_KEY }iluo`,
} as const );

export const ABILITY_COLUMN = Object.freeze( {
  SITE_NAME: `${ PREFIX_EXPORT_KEY }site_name`,
  NAME: `${ PREFIX_EXPORT_KEY }ability_name`,
  COLOR: `${ PREFIX_EXPORT_KEY }color`,
  EMAIL: `${ PREFIX_EXPORT_KEY }email`,
  EXPIRATION_DATE: `${ PREFIX_EXPORT_KEY }expiration_date`,
} as const );

export const EQUIPMENT_COLUMN = Object.freeze( {
  SITE_NAME: `${ PREFIX_EXPORT_KEY }site_name`,
  SECTOR_NAME: `${ PREFIX_EXPORT_KEY }sector_name`,
  NAME: `${ PREFIX_EXPORT_KEY }equipment_name`,
  EXPIRATION_DATE: `${ PREFIX_EXPORT_KEY }expiration_date`,
  DESCRIPTION: `${ PREFIX_EXPORT_KEY }description`,
  ABILITY_NAME: `${ PREFIX_EXPORT_KEY }ability_name`,
  SKILL_NAME: `${ PREFIX_EXPORT_KEY }skill_name`,
  ILUO: `${ PREFIX_EXPORT_KEY }iluo`,
} as const );